export const secondaryRouters = {
  path: '',
  name: 'secondary',
  component: () => import('@/layouts/Secondary'),
  redirect: '/',
  children: [
    {
      path: '',
      name: 'login',
      component: () => import('@/views/Login'),
      meta: {
        noAuth: true
      }
    }
  ]
}
